<template>
    <div class="popup" v-show="show">
        <div class="create bg_white">
            <Icon class="closer cursor_pointer" type="md-close" @click="show=false" size="26"/>
            <div class="title f18 bold500 txt_black87 tc">退款审核</div>
            <textarea class="description" cols="30" rows="10" v-model="description"></textarea>
            <div class="images">
                <img v-for="(v,key) in images" :key="key" :src="v">
            </div>
            <div class="submit tc">
                <button class="bg_E91E63 f18 bold400 txt_white tc cursor_pointer" @click="submitEvent">通过</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "create",
        data() {
            return {
                show: false,
                id: null,
                description: '',
                images: []
            }
        },
        methods: {
            init(id,description,images) {
                this.show = true;
                this.id = id;
                this.description = description;
                this.images = images.map(item => {
                    return 'http://manage.scadkj.com/' + item;
                });
            },
            submitEvent() {
                this.$api.put('/manage/refund/' + this.id,{
                    status: 1
                }).then((data) => {
                    this.$alert.success({content: '退款审核通过'});
                    this.show = false;
                    this.$emit('updateData');
                }).catch((error) => {
                    this.$alert.error({content: '退款审核失败，请重试'});
                });
            }
        }
    }
</script>

<style scoped>
    .create {
        width: 1000px;
        height: 800px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -400px 0 0 -500px;
        border-radius: 5px;
    }
    .description {
        margin: 20px;
        width: 960px;
        height: 150px;
        border: 1px rgba(75, 75, 75, 0.63) solid;
        border-radius: 5px;
    }
    .images {
        margin: 0 20px;
        width: 960px;
        height: 430px;
        overflow: auto;
    }
    .images > img {
        margin-right: 20px;
    }
</style>